import React from 'react';
import { motion } from 'framer-motion';
import { useLocation } from 'react-router-dom';

const slideVariants = {
  initial: (direction) => ({
    opacity: 0,
    x: direction === 'forward' ? '100%' : '-100%'
  }),
  enter: {
    opacity: 1,
    x: 0,
    transition: {
      duration: 0.3,
      ease: [0.22, 1, 0.36, 1]
    }
  },
  exit: (direction) => ({
    opacity: 0,
    x: direction === 'forward' ? '-100%' : '100%',
    transition: {
      duration: 0.3,
      ease: [0.22, 1, 0.36, 1]
    }
  })
};

function PageTransition({ children, className = "" }) {
  const location = useLocation();

  // 根据路径深度判断动画方向
  const getDirection = () => {
    const mainRoutes = ['/', '/menu', '/phrase', '/exchange'];
    const currentIndex = mainRoutes.indexOf(location.pathname);
    const prevPath = sessionStorage.getItem('prevPath') || '/';
    const prevIndex = mainRoutes.indexOf(prevPath);
    
    sessionStorage.setItem('prevPath', location.pathname);
    return currentIndex > prevIndex ? 'forward' : 'backward';
  };

  return (
    <motion.div
      initial="initial"
      animate="enter"
      exit="exit"
      variants={slideVariants}
      custom={getDirection()}
      className={`${className} fixed inset-0 overflow-y-auto`}
    >
      {children}
    </motion.div>
  );
}

export default PageTransition; 